export const checkIfLocal = ()=>{
    const loc = window.location.href
    if (loc.includes("://localhost")){
        return true
    }
    return false
}